export const ON_FINISH_DATE_CHANGED = 'workItemForm/FINISH_DATE_CHANGED';
export const ON_STARTED_DATE_CHANGED = 'workItemForm/ON_STARTED_DATE_CHANGED';
export const ON_DURATION_CHANGED = 'workItemForm/ON_DURATION_CHANGED';
